module.exports = __webpack_public_path__ + "../resources/images/illustration_attachment-f8f6c3c914e52f25ff0db5189967ce1d.svg";